import { Route, Routes } from 'react-router-dom-v5-compat'

import { RedirectPage } from '@sparkai/auth'

import { CanonicalEngagementLink } from './components/CanonicalEngagementLink'
import { CanonicalTaskLink } from './components/CanonicalTaskLink'
import { Fallback } from './components/Fallback'
import { Redirector } from './components/Redirector'
import { RequestDetails } from './components/RequestDetails'
import { TaskOutcome } from './components/TaskOutcome'
import { TrainingModuleTask } from './components/TrainingModuleTask'

export function AppRoutes() {
  return (
    <Routes>
      <Route path='auth'>
        <Route path='redirect' element={<RedirectPage />} />
      </Route>
      <Route path='redirect' element={<Redirector />} />
      <Route path='engagement/:engagementId' element={<CanonicalEngagementLink />} />
      <Route path='task/:taskId' element={<CanonicalTaskLink />} />
      <Route path='task-outcome' element={<TaskOutcome />} />
      <Route path='training-module-task' element={<TrainingModuleTask />} />
      <Route path='request/:requestId' element={<RequestDetails />} />
      <Route path='*' element={<Fallback />} />
    </Routes>
  )
}
